import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Menu from './pages/Menu';
import Gifts from './pages/Gifts';
import Group from './pages/Group';
import Reservation from './pages/Reservation';
import WhatsOn from './pages/WhatsOn';
import JoinTeam from './pages/JoinTeam';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/gifts" element={<Gifts />} />
            <Route path="/group" element={<Group />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/whatson" element={<WhatsOn />} />
            <Route path="/join-team" element={<JoinTeam />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
